import {Injectable} from '@angular/core';
import {Form} from "../../models/form";
import {QUESTION_TYPES, QuestionData, QuestionParameters} from "./form-question.directive";
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {TextInputComponent} from "../../shared/components/inputs/text-input/text-input.component";
import {SelectInputComponent} from "../../shared/components/inputs/select-input/select-input.component";
import {RadioGroupComponent} from "../../shared/components/inputs/radio-group-input/radio-group.component";
import {
  SelectMultipleInputComponent
} from "../../shared/components/inputs/select-multiple-input/select-multiple-input.component";
import {TextListInputComponent} from "../../shared/components/inputs/text-list-input/text-list-input.component";
import {FilesInputComponent} from "../../shared/components/inputs/files-input/files-input.component";
import {StatusSelectorComponent} from "../../shared/components/inputs/status-selector-input/status-selector.component";
import {TableInputComponent} from "../../shared/components/inputs/table-input/table-input.component";
import {TemplateInputComponent} from "../../shared/components/inputs/template-input/template-input.component";
import { v4 as uuidv4 } from 'uuid';
@Injectable()
export class AppFormService {

  readonly componentControls = {
    [QUESTION_TYPES.TEXT]: new TextInputComponent(),
    [QUESTION_TYPES.LIST]: new SelectInputComponent(),
    [QUESTION_TYPES.SINGLE_OPTION]: new RadioGroupComponent(),
    [QUESTION_TYPES.MULTIPLE_ANSWERS]: new SelectMultipleInputComponent(),
    [QUESTION_TYPES.ANSWERS_LIST]: new TextListInputComponent(),
    [QUESTION_TYPES.FILES]: new FilesInputComponent(),
    [QUESTION_TYPES.STATUS]: new StatusSelectorComponent(),
    [QUESTION_TYPES.TABLE]: new TableInputComponent(),
    [QUESTION_TYPES.TEMPLATE]: new TemplateInputComponent(),
  }

  constructor() {
  }

  parseFormFromAPI(form: Form): {data: QuestionData<any>, params: QuestionParameters}[] {
    return form.questions.map(question => {
      let data: QuestionData<any> = {
        questionId: question.id,
        answerId: question.answerId,
        answer: JSON.parse(question.answer)?.value,
        attachments: question.attachments.map(f => f.id),
        comments: question.comments.map(comment => comment.comment),
      };
      const params: QuestionParameters = {
        type: question.questionTypeId,
        description: question.description,
        explanation: question.detail,
        attachments: question.attachments.map(a => a.file),
        tableConfig: {columns: question.dimensions},
        files: question.answerFiles,
        colorItems: question.possibleAnswers,
        items: question.possibleAnswers,
        template: question.templateFileId,
        attachAllowed: question.attachAllowed,
        attachRequired: question.attachRequired,
        commentRequired: question.commentRequired,
        commentAllowed: question.commentAllowed,
        isRequired: question.isRequired,
        conditionalGroup: question.conditionalGroup,
        tag :  uuidv4()
      }
      return {
        data,
        params,
      }
    })
  }

  getFormAndParams(form: Form): { form: FormGroup, params: {[key: string]: QuestionParameters} } {
    const questions = this.parseFormFromAPI(form);
    return questions.reduce((formAndParams, question) => {

      const answerControl = new FormControl(question.data.answer || this.getDefaultAnswer(question.params));
      if (question.params.isRequired) {
        answerControl.setValidators([Validators.required]);
      }

      formAndParams.form.addControl(
        question.data.questionId as any,

        new FormGroup({
          questionId: new FormControl(question.data.questionId),
          answerId: new FormControl(question.data.answerId),
          answer: answerControl,
          attachments: new FormControl(question.data.attachments, question.params.attachRequired ? [Validators.required] : null),
          /*        attachments: new FormArray(question.data.attachments
            .map(attach => new FormControl(attach,
              question.params.attachRequired ? [Validators.required] : null))),*/
          comments: new FormArray((question.data.comments?.length ? question.data.comments : [''])
            .map(comment => new FormControl(comment,
              question.params.commentRequired ? [Validators.required] : null))),
        })
      );
      formAndParams.params[question.data.questionId] = question.params;
      return formAndParams;
    }, {form: new FormGroup({}), params: {}})
  }

  getComponentControl(type: QUESTION_TYPES){
    return this.componentControls[type];
  }

  getDefaultAnswer(params: QuestionParameters) {
    return this.getComponentControl(params.type)?.defaultValue;
  }
}
